import { useState } from 'react';

/**
 * A custom hook for managing sort state
 * @param {string} initialSortBy - The initial sort value
 * @returns {[string, (newSortBy: string) => void]} - The sort state and a function to update it
 */
const useSortState = (initialSortBy) => {
  const [sortBy, setSortBy] = useState(initialSortBy);

  const handleSortChange = (newSortBy) => {
    setSortBy(newSortBy);
  };

  return [sortBy, handleSortChange];
};

export default useSortState; 